export const CHROME_EXTENSION_URL =
	'https://chromewebstore.google.com/detail/lfchhaglacfkjfdilopofmgjnljfaihg?utm_source=item-share-cb'
